// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yOut","title":"Header_title__1xDrk","side":"Header_side__3Hj5L"};